// extracted by mini-css-extract-plugin
module.exports = {"selectTitle":"BestPracticeIconSelect-selectTitle-1sa8bxdNIZ","iconPadding":"BestPracticeIconSelect-iconPadding-19uG0BG74p"};